import {
  buildIbRedirectUrl,
  withIbReturnUrl,
} from "features/healthlink/utils/ibRedirect";

import { PENDING_IB_LAB_ORDER_KEY } from "../constants";

// How long to wait before deciding the redirect did not happen. A successful one unloads
// the page long before this; if we are still here, the browser blocked it or the
// CloudFront rewrite is unavailable, and the GP needs the copy-link fallback. Same 2.5s
// the referral flow uses.
export const IB_REDIRECT_FALLBACK_MS = 2500;

// Healthlink drops our query params on the way back and returns only its own ?controlId,
// so the order id is stashed where it survives a full-page navigation.
export const rememberPendingLabOrder = (labOrderId) => {
  if (!labOrderId) return;

  sessionStorage.setItem(PENDING_IB_LAB_ORDER_KEY, String(labOrderId));
};

// Where to send the browser to reach Healthlink: our own CloudFront redirect, carrying the
// Integrated Browser URL plus a return address back to the page the GP started from.
export const buildLabOrderIbRedirect = (submission, currentHref) => {
  if (!submission?.integratedBrowserUrl) return "";

  const returnUrl = new URL(currentHref);

  if (submission.id) {
    returnUrl.searchParams.set("labOrderId", String(submission.id));
  }

  return buildIbRedirectUrl(
    withIbReturnUrl(submission.integratedBrowserUrl, returnUrl.toString())
  );
};
